// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLuckyWheel_root__AcKJ9","text":"ButtonLuckyWheel_text__BZluw","bg":"ButtonLuckyWheel_bg__4vQFr"};